<template>
  <Card v-show="isActive">
    <slot />
  </Card>
</template>

<script>
import Card from './Card'
export default {
  name: 'Tab',
  components: { Card },
  props: {
    title: {
      type: String,
      default: 'Tab'
    },
    active: {
      type: Boolean,
      default: false
    },
    name: String
  },
  data () {
    return {
      isActive: this.active,
      value: this.title
    }
  },
  methods: {
    getIsActive () {
      return this.isActive
    }
  }
}
</script>
